const localizers = {
  'Alerts.noAlerts.txt': () => `No alerts are set for this report.`,
  'BirdImage.image.txt': () => `Image`,
  'BirdText.editable.tooltip.txt': () => `Double-click to edit text`,
  'ComboBox.clearFilter.txt': () => `Clear filter`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (No Data)`,
  'ContextMenu.selectAll.txt': () => `Select all`,
  'ContextMenu.clearSelection.txt': () => `Clear selection`,
  'ContextMenu.exportImage.txt': () => `Export as Image`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Ascending`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Descending`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Add ascending`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Add descending`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Remove ${role} from sort`,
  'ContextMenu.removeSortLevel.txt': () => `Remove sort level`,
  'ContextMenu.sort.txt': () => `Sort`,
  'ContextMenu.selectShortestPath.txt': () => `Select shortest path`,
  'ContextMenu.explain.txt': () => `Explain data`,
  'ContextMenu.explainRole.txt': ({role}) => `Explain ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Manage columns`,
  'ContextMenu.includeMissingValues.txt': () => `Include missing values`,
  'DrillableTooltip.drill.txt': () => `DRILL`,
  'DrillableTooltip.tooltip.txt': () => `TOOLTIP`,
  'DrillableTooltip.links.txt': () => `LINKS`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Page Link to ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Report Link to ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `External Link to ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Not available`,
  'Breadcrumb.all.fmt': ({label}) => `All ${label}`,
  'BrowserCheck.title.txt': () => `WebGL Check`,
  'BrowserCheck.msg.txt': () => `WebGL is either disabled or not supported by your browser.   \nClick OK to view the report in the classic viewer.`,
  'EmailUtil.subject.multiple.txt': () => `Reports for review`,
  'EmailUtil.tooLongEmail.txt': () => `The email length limit was exceeded. Select fewer reports to email.`,
  'HiddenSectionDialog.close.txt': () => `Close`,
  'HiddenSectionDialog.export.txt': () => `Export as PDF`,
  'InfoPanel.information.txt': () => `Information`,
  'InfoPanel.comments.txt': () => `Comments`,
  'InfoPanel.alerts.txt': () => `Alerts`,
  'IncomingFilters.promptbars.txt': () => `Prompt Bars`,
  'Information.title.txt': () => `Title`,
  'Information.name.txt': () => `Name:`,
  'Information.description.txt': () => `Description:`,
  'Information.displayRules.txt': () => `Display rules:`,
  'Information.graphLevel.txt': () => `Graph Level`,
  'Information.reportLevel.txt': () => `Report Level`,
  'Information.legend.txt': () => `Legend`,
  'Information.incomingFilters.txt': () => `Incoming filters:`,
  'Information.noIncomingFilters.txt': () => `No Incoming Filters`,
  'Information.dataSourceFilters.txt': () => `Data source filters:`,
  'Information.interactiveFilters.txt': () => `Interactive filters:`,
  'MobileContainer.mobileBIMessage.txt': () => `Access SAS reports on your mobile device.`,
  'ObjectTypes.report.txt': () => `Report`,
  'ObjectTypes.Report.BI.txt': () => `SAS report (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Stored process`,
  'MissingValues.label.txt': () => `(missing values)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Cancel`,
  'PromptContainer.close.txt': () => `Close`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Value must be a number between ${min} and ${max}, inclusive.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Specify a valid numeric value.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Value is not valid for the assigned data.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Enter: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Enter: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Enter ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'Slider.missingValues.txt': () => `Missing values`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Back`,
  'ReportContainer.reportCorrupted.txt': () => `REPORT CORRUPTED`,
  'ReportContainer.themeLoadFailed.txt': () => `Failed to load report theme.`,
  'ReportContainer.restoreButton.tip.txt': () => `Restore report`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Report restored`,
  'ReportContainer.renderError.txt': () => `An error occurred. The report could not be displayed.`,
  'ReportContainer.component.renderError.txt': () => `An error occurred. The component could not be rendered.`,
  'ReportContentPage.open.txt': () => `Open...`,
  'ReportContentPage.refreshReport.txt': () => `Refresh report`,
  'ReportContentPage.editReport.txt': () => `Edit report`,
  'ReportContentPage.print.txt': () => `Print...`,
  'ReportContentPage.email.txt': () => `Email...`,
  'ReportContentPage.export.txt': () => `Export to Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Report Properties`,
  'ReportContentPage.shareReport.txt': () => `Share report`,
  'ReportContentPage.enableOverlays.txt': () => `Enable object overlays`,
  'ReportContentPage.disableOverlays.txt': () => `Disable object overlays`,
  'ReportContentPage.link.txt': () => `Link...`,
  'ReportContentPage.settings.txt': () => `Settings...`,
  'ReportContentPage.editPlayback.txt': () => `Edit playback`,
  'ReportContentPage.playReport.txt': () => `Play report`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Show prompted filters`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Hide prompted filters`,
  'ReportContentPage.reportFilters.txt': () => `Report level`,
  'ReportContentPage.pageFilters.txt': () => `Page level`,
  'ReportContentPage.refreshRequired.txt': () => `Report refresh is required`,
  'ReportContentPage.infoButton.tip.txt': () => `Information Panel`,
  'ReportContentPage.backButton.tip.txt': () => `View all reports`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `More options`,
  'ReportContentPage.itemGroupName.txt': () => `Reports`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Maximize report`,
  'ReportContentPage.closeButton.txt': () => `Close report`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Report maximized`,
  'ReportContentPage.resetReportState.txt': () => `Restore default report state`,
  'ReportContentPage.summary.txt': () => `Show summary`,
  'ReportManagerPage.objectMenu.open.txt': () => `Open`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Edit`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Summary`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Properties`,
  'ReportManagerPage.objectMenu.email.txt': () => `Email...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Print`,
  'ReportManagerPage.browseReportsButton.txt': () => `Browse Reports`,
  'ReportManagerPage.newReportButton.txt': () => `New Report`,
  'ReportManagerPage.emptyView.message.txt': () => `No reports were found.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Browse for Reports`,
  'ReportManagerPage.tableView.name.txt': () => `Name`,
  'ReportManagerPage.tableView.author.txt': () => `Author`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Last Modified`,
  'ReportManagerPage.openButton.tip.txt': () => `Open report`,
  'ReportManagerPage.emailButton.tip.txt': () => `Email report`,
  'ReportManagerPage.printButton.tip.txt': () => `Print report to PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Report properties`,
  'ReportObject.multipleReferences.error.txt': () => `Report objects cannot be used in multiple contexts.`,
  'ReportObject.notFound.error.txt': () => `The object name cannot be found in the specified report.`,
  'ReportObject.invalidPage.error.txt': () => `The specified page is invalid.`,
  'ReportPropertiesDialog.open.txt': () => `Open`,
  'ReportPropertiesDialog.close.txt': () => `Close`,
  'ReportPropertiesDialog.name.txt': () => `Name:`,
  'ReportPropertiesDialog.description.txt': () => `Description:`,
  'ReportPropertiesDialog.keywords.txt': () => `Keywords:`,
  'ReportPropertiesDialog.type.txt': () => `Type:`,
  'ReportPropertiesDialog.location.txt': () => `Location:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Created by:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Date created:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Modified by:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Date modified:`,
  'ReportSections.newPageButton.txt': () => `New page`,
  'ReportSections.closeTab.tooltip.txt': () => `Delete page`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `${label} menu`,
  'ReportSummaryDialog.title.txt': () => `Summary`,
  'ReportSummaryDialog.open.txt': () => `Open`,
  'ReportSummaryDialog.cancel.txt': () => `Cancel`,
  'ReportSummaryDialog.close.txt': () => `Close`,
  'ReportSummaryDialog.noSummary.txt': () => `No summary is available.`,
  'ReportTileBody.modifiedBy.txt': () => `Modified by:`,
  'ReportTileBody.lastModified.txt': () => `Last modified:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Report Refresh`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Report Auto-Refresh`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Check for updates after this number of minutes:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Alert Notifications`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Select the default alert notifications:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Send e-mail messages`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Send SMS text messages`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Administrator default`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Themes`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Override the report theme and use the SAS High Contrast report theme`,
  'ViewerBusyDialog.openReport.txt': () => `Opening report...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Preparing export...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Preparing to print...`,
  'PDFGeneration.printingReport.txt': () => `Generating report PDF. It will download when ready.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} on ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Select an action`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `You have reached the lowest level of the hierarchy.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `You have reached the lowest level of all hierarchies.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Drill into ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Snapshot of ${a0} ${a1} at ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Save image`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Print object...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Share object...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `More`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Object menu for ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `View with SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Zoom`,
  'ZoomControl.button.zoomin.txt': () => `Zoom in`,
  'ZoomControl.button.zoomout.txt': () => `Zoom out`,
  'ZoomControl.button.display.txt': () => `Zoom Controls`,
  'ZoomControl.button.reset.txt': () => `Reset zoom`,
  'ExpandControl.button.expand.txt': () => `Maximize view`,
  'ExpandControl.button.restore.txt': () => `Restore view`,
  'ExpandControl.button.expand.tip.txt': () => `Maximize`,
  'ExpandControl.button.restore.tip.txt': () => `Restore`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Page links cannot be executed while this object is maximized.`,
  'DragModeControl.button.pan.tip.txt': () => `Pan`,
  'DragModeControl.button.circular.tip.txt': () => `Circular selection`,
  'DragModeControl.button.freeform.tip.txt': () => `Free-form selection`,
  'DragModeControl.button.rectangular.tip.txt': () => `Rectangular selection`,
  'DragModeControl.button.zoom.tip.txt': () => `Zoom to rectangle`,
  'ReportXMLDialog.title.txt': () => `Report XML`,
  'ReportXMLDialog.closeButton.txt': () => `Close`,
  'ReportXMLDialog.copyButton.txt': () => `Copy to Clipboard`,
  'ReportXMLDialog.error.txt': () => `Error loading report XML`,
  'ErrorDialog.error.txt': () => `An error occurred. Please contact your system administrator.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Open Report`,
  'OpenReportDialog.reports.txt': () => `Reports:`,
  'OpenReportDialog.cancel.txt': () => `Cancel`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} objects updated`,
  'AriaLive.oneObjectUpdated.txt': () => `1 object updated`,
  'AriaLive.reportOpened.txt': () => `Report opened`,
  'AriaLive.reportClosed.txt': () => `Report closed`,
  'ExportData.generating.txt': () => `Generating export. It will download when ready.`,
  'ExportData.warning.txt': () => `Error generating data`,
  'ExportData.nodata.txt': () => `No data to export`,
  'ExportData.exportData.txt': () => `Export data...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Save`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Cancel`,
  'PlaybackAnimationDialog.playButton.txt': () => `Play report`,
  'PlaybackAnimationDialog.title.txt': () => `Edit Playback`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Transition unit:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Page`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Object`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Seconds per unit:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Show maximized objects:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Show canvas only:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Show timer:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Show navigation controls upon click or touch:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Previous page`,
  'PlaybackNavigationControls.nextPage.txt': () => `Next page`,
  'PlaybackNavigationControls.previousObject.txt': () => `Previous object`,
  'PlaybackNavigationControls.nextObject.txt': () => `Next object`,
  'TransportConnection.generateReportTimeout.txt': () => `The report is taking a long time to load. Do you want to continue?`,
  'TransportConnection.openReport.txt': () => `Open Report`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `The specified report at the following location does not exist: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Expand ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Collapse ${label}`,
  'GraphElementDecorator.overview.txt': () => `Overview`,
  'GraphElementDecorator.layers.txt': () => `Hide or show layers`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Hide Overview`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Show Overview`,
  'TitleInfoButton.tooltip.txt': () => `Information`,
  'SectionSelectionBar.noSelections.txt': () => `No selections`,
  'SectionSelectionBar.title.txt': () => `Filters:`,
  'CheckboxList.selectAll.txt': () => `Select all`,
  'CheckboxList.clearSelection.txt': () => `Clear selection`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Clear selection (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Explaining ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Preparing explanation...`,
  'ExplanationInfoDialog.cancel.txt': () => `Cancel`,
  'ExplanationInfoDialog.close.txt': () => `Close`,
  'PromptHeader.emptyReport.txt': () => `Drag a data item or control here to create a report prompt.`,
  'PromptHeader.emptyPage.txt': () => `Drag a data item or control here to create a page prompt.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Collapse page control area`,
  'PromptHeader.expandPageControlArea.txt': () => `Expand page control area`,
  'PromptHeader.collapseReportControlArea.txt': () => `Collapse report control area`,
  'PromptHeader.expandReportControlArea.txt': () => `Expand report control area`,
  'PromptHeader.collapseControlArea.txt': () => `Collapse control area`,
  'PromptHeader.expandControlArea.txt': () => `Expand control area`,
  'PromptHeader.reportControlArea.txt': () => `Report control area`,
  'PromptHeader.allControlAreas.txt': () => `All control areas`,
  'PromptHeader.pageControlArea.txt': () => `Page control area`,
  'ZeroState.editMode.txt': () => `Drag a template, data items, or objects here.`,
  'ZeroState.viewMode.txt': () => `No content to display.`,
  'ObjectStatus.assignData.txt': () => `Assign data`,
  'ObjectStatus.selectImage.txt': () => `Select image`,
  'ObjectStatus.selectJob.txt': () => `Select job`,
  'ObjectStatus.cancelLoading.txt': () => `Cancel loading`,
  'ObjectStatus.loadingCanceled.txt': () => `Loading canceled`,
  'ObjectStatus.resumeLoading.txt': () => `Resume loading`,
  'ObjectStatus.refresh.txt': () => `Refresh`,
  'ObjectStatus.setJobParameters.txt': () => `Set parameter values`,
  'ObjectSearch.title.txt': () => `Geographic search`,
  'ObjectSearch.pin.txt': () => `Pin`,
  'ObjectSearch.unpin.txt': () => `Unpin`,
  'MainSearchPanel.searchHints.txt': () => `Search Hints`,
  'MainSearchPanel.searchResults.txt': () => `Search Results`,
  'MainSearchPanel.features.txt': () => `Features`,
  'MainSearchPanel.pin.txt': () => `New pin`,
  'MainSearchPanel.pin.tooltip.txt': () => `New pin`,
  'MainSearchPanel.route.txt': () => `New route`,
  'MainSearchPanel.route.tooltip.txt': () => `New route`,
  'MainSearchPanel.geographicArea.txt': () => `New geo area`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `New geographic area`,
  'MainSearchPanel.newMyLocationPin.txt': () => `My location pin`,
  'MainSearchPanel.myLocationPin.txt': () => `My Location`,
  'MainSearchPanel.show.txt': () => `Show`,
  'MainSearchPanel.show.all.txt': () => `Show all`,
  'MainSearchPanel.hide.txt': () => `Hide`,
  'MainSearchPanel.hide.all.txt': () => `Hide all`,
  'MainSearchPanel.delete.txt': () => `Delete`,
  'MainSearchPanel.delete.all.txt': () => `Delete all`,
  'MainSearchPanel.convert.txt': () => `Convert search results to pins`,
  'MainSearchPanel.convert.all.txt': () => `Convert all search results to pins`,
  'MainSearchPanel.showPinLabels.txt': () => `Show pin labels`,
  'MainSearchPanel.close.label.txt': () => `Geographic search`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Show details`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demographics`,
  'PanelHeader.back.tooltip.txt': () => `Back`,
  'GeographicAreaPanel.title.txt': () => `Geographic Area`,
  'GeographicAreaPanel.draw.txt': () => `Draw area`,
  'GeographicAreaPanel.update.txt': () => `Update area`,
  'GeographicAreaPanel.label.txt': () => `Label:`,
  'GeographicAreaPanel.location.txt': () => `Location:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Distance (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Distance (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Add distance`,
  'GeographicAreaPanel.time.add.txt': () => `Add time`,
  'GeographicAreaPanel.distance.delete.txt': () => `Delete distance`,
  'GeographicAreaPanel.time.minutes.txt': () => `Time (min):`,
  'GeographicAreaPanel.duration.txt': () => `Duration:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Miles`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometers`,
  'GeographicAreaPanel.menu.clear.txt': () => `Clear geographic area`,
  'GeographicAreaPanel.menu.link.txt': () => `Link address to data elements and pins by default`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Unlink geographic area address`,
  'GeographicAreaPanel.menu.delete.txt': () => `Delete geographic area`,
  'GeographicAreaPanel.demographics.txt': () => `Demographics`,
  'GeographicAreaPanel.demographics.set.txt': () => `Show demographics`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Expand view`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Edit demographics`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Delete demographics`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Demographics data must be reloaded`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Reload demographics`,
  'GeographicAreaPanel.invalid.location.txt': () => `The geographic area does not have a valid location and cannot be created.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Select a day and time`,
  'TravelTypeField.cancel.txt': () => `Cancel`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Select a day and time`,
  'TravelTypeField.day.txt': () => `Day:`,
  'TravelTypeField.time.txt': () => `Time:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Direct`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Distance`,
  'TravelTypeField.travelType.txt': () => `Travel type:`,
  'TravelTypeField.traffic.txt': () => `Include traffic:`,
  'TravelTypeField.traffic.offset.txt': () => `Traffic time offset:`,
  'TravelTypeField.traffic.daytime.txt': () => `Traffic day and time:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Distance unit`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Driving distance`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Driving time`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Trucking distance`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Trucking time`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Walking distance`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Walking time`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `No`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Current traffic`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Typical traffic`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} hr`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Update traffic for this feature`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Update traffic for all features`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Update traffic data`,
  'RoutePanel.title.txt': () => `Route`,
  'RoutePanel.draw.txt': () => `Draw route`,
  'RoutePanel.update.txt': () => `Update route`,
  'RoutePanel.label.txt': () => `Label:`,
  'RoutePanel.locations.txt': () => `Locations`,
  'RoutePanel.menu.clear.txt': () => `Clear route`,
  'RoutePanel.menu.reverse.txt': () => `Reverse route`,
  'RoutePanel.menu.add.waypoint.txt': () => `Add route location`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Delete route location`,
  'RoutePanel.menu.unlink.txt': () => `Unlink route location`,
  'RoutePanel.menu.arrows.txt': () => `Route arrows`,
  'RoutePanel.menu.arrows.hide.txt': () => `Hide route arrows`,
  'RoutePanel.menu.arrows.show.txt': () => `Show route arrows`,
  'RoutePanel.menu.arrows.oneway.txt': () => `One-way`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Two-way`,
  'RoutePanel.menu.delete.txt': () => `Delete route`,
  'RoutePanel.route.width.txt': () => `Route width`,
  'RoutePanel.distance.txt': () => `Distance:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mi`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Add location`,
  'RoutePanel.location.delete.txt': () => `Delete location`,
  'RoutePanel.duration.txt': () => `Time:`,
  'RoutePanel.invalid.location.txt': () => `The route has no valid locations and cannot be created.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Location ${index}, ${location}, input`,
  'PinPanel.pinTitle.txt': () => `Pin`,
  'PinPanel.addDescription.txt': () => `Add description`,
  'PinPanel.deleteDescription.txt': () => `Delete description`,
  'PinPanel.newPin.txt': () => `New pin at this location`,
  'PinPanel.deletePin.txt': () => `Delete pin`,
  'PinPanel.linkPins.txt': () => `Link pins to data elements by default`,
  'PinPanel.unlinkAllItems.txt': () => `Unlink all items`,
  'PinPanel.unlinkItems.txt': () => `Unlink items`,
  'PinPanel.label.txt': () => `Label:`,
  'PinPanel.location.txt': () => `Location:`,
  'PinPanel.description.txt': () => `Description:`,
  'PinPanel.linked.txt': () => `LINKED`,
  'PinPanel.searchClickPlaceholder.txt': () => `Search or select on the map`,
  'PinPanel.searchPlaceholder.txt': () => `Search`,
  'PinPanel.addRoute.txt': () => `Add route`,
  'PinPanel.addRoute.tooltip.txt': () => `Add route`,
  'PinPanel.addArea.txt': () => `Add geo area`,
  'PinPanel.addArea.tooltip.txt': () => `Add geographic area`,
  'PinPanel.addArea.title.txt': () => `Add Geographic Area`,
  'PinPanel.myLocationTitle.txt': () => `My Location Pin`,
  'PinPanel.deleteMyLocationPin.txt': () => `Delete My Location pin`,
  'PinPanel.enableAutoUpdate.txt': () => `Enable My Location auto-update`,
  'PinPanel.disableAutoUpdate.txt': () => `Disable My Location auto-update`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Edit My Location auto-refresh interval...`,
  'PinPanel.linkToPin.txt': () => `Link to pin`,
  'PinPanel.useCurrentLocation.txt': () => `Use current location of pin`,
  'PinPanel.notDrawn.txt': () => `Not drawn`,
  'PinPanel.undetermined.txt': () => `Undetermined`,
  'PinPanel.findMyLocation.txt': () => `Find My Location`,
  'PinPanel.cannotDetermineLocation.txt': () => `The application cannot determine your current location. If you want to share your location, see the help for your browser or device.`,
  'PinPanel.autoRefreshInterval.txt': () => `My Location Auto-Refresh Interval`,
  'PinPanel.interval.hours.txt': () => `Hours:`,
  'PinPanel.interval.minutes.txt': () => `Minutes:`,
  'PinPanel.interval.seconds.txt': () => `Seconds:`,
  'PinPanel.invalid.location.txt': () => `The pin does not have a valid location and cannot be created.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}, ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}, ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}, ${value2} min`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} min`,
  'PinPanel.clearLocation.tooltip.txt': () => `Clear location text`,
  'DiscardChangesDialog.title.area.txt': () => `Geographic Area`,
  'DiscardChangesDialog.title.route.txt': () => `Route`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `You made changes to the geographic area but did not redraw the area.\n\nDo you want to discard the changes to ${label}?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `You made changes to the geographic route but did not redraw the route.\n\nDo you want to discard the changes to ${label}?`,
  'DiscardChangesDialog.discard.txt': () => `Discard`,
  'DiscardChangesDialog.cancel.txt': () => `Cancel`,
  'FeatureErrorDialog.title.area.txt': () => `Draw Geographic Area`,
  'FeatureErrorDialog.title.route.txt': () => `Draw Route`,
  'FeatureErrorDialog.text.area.txt': () => `The geographic area could not be drawn..\n\nTip: If your area's location does not contain travel infrastructure such as roads, then it might not be possible to calculate a geographic area. Use a distance travel type instead, or move the area to a location that has travel infrastructure.`,
  'FeatureErrorDialog.text.route.txt': () => `The route could not be drawn..\n\nTip: If your route's location does not contain travel infrastructure such as roads, then it might not be possible to calculate a route. Use a distance travel type instead, or move the route to a location that has travel infrastructure.`,
  'FeatureErrorDialog.close.txt': () => `Close`,
  'DemographicsSelectorDialog.title.txt': () => `Show Demographics`,
  'DemographicsSelectorDialog.cancel.txt': () => `Cancel`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Country/Region`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Basic`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Advanced`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Recent`,
  'DemographicsSelectorDialog.categories.txt': () => `Categories`,
  'DemographicsSelectorDialog.category.income.txt': () => `Income`,
  'DemographicsSelectorDialog.category.age.txt': () => `Age`,
  'DemographicsSelectorDialog.category.households.txt': () => `Households`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Housing`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Marital Status`,
  'DemographicsSelectorDialog.category.population.txt': () => `Population`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `User Group`,
  'DemographicsSelectorDialog.category.health.txt': () => `Health`,
  'DemographicsSelectorDialog.category.education.txt': () => `Education`,
  'DemographicsSelectorDialog.category.business.txt': () => `Business`,
  'DemographicsSelectorDialog.category.race.txt': () => `Race`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Spending`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Behaviours`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Jobs`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Poverty`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Tapestry`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `At Risk`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Key Facts`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Supply and Demand`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Policy`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Landscape`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Crime`,
  'ManageColumns.title.txt': () => `Manage Columns`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Cancel`,
  'ManageColumns.hiddenColumns.txt': () => `Hidden columns`,
  'ManageColumns.displayedColumns.txt': () => `Displayed columns`,
  'SearchResultPanel.title.txt': () => `Search Result`,
  'SearchResultPanel.menu.delete.txt': () => `Delete search result`,
  'SearchResultPanel.convert.txt': () => `Convert to pin`,
  'SearchResultPanel.convert.tooltip.txt': () => `Convert to pin`,
  'DemographicsResultsDialog.title.txt': () => `Demographics`,
  'DemographicsResultsDialog.cancel.txt': () => `Cancel`,
  'DemographicsResultsDialog.close.txt': () => `Close`,
  'DemographicsResultsDialog.edit.txt': () => `Edit`,
  'DemographicsResultsDialog.layout.page.txt': () => `Carousel view`,
  'DemographicsResultsDialog.layout.list.txt': () => `Single column view`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Tile view`,
  'DemographicsResultsDialog.noData.txt': () => `No data matches the current geographic area.`,
  'PinsAtSameLocationPanel.title.txt': () => `Pins at the Same Location`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `SEARCH RESULTS`,
  'PinsAtSameLocationPanel.pins.txt': () => `PINS`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Show all`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Hide all`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Delete all`,
  'PinsAtSameLocationPanel.show.txt': () => `Show`,
  'PinsAtSameLocationPanel.hide.txt': () => `Hide`,
  'PinsAtSameLocationPanel.delete.txt': () => `Delete`,
  'LocationPopover.pin.title.txt': () => `Pin Location`,
  'LocationPopover.area.title.txt': () => `Geographic Area Location`,
  'LocationPopover.route.title.txt': ({label}) => `Route Location ${label}`,
  'LocationPopover.name.txt': () => `Name`,
  'LocationPopover.location.txt': () => `Location:`,
  'LocationPopover.ok.txt': () => `Set location`,
  'LocationPopover.cancel.txt': () => `Exit selection mode`,
  'LocationPopover.hint.txt': () => `Click the map again to identify a different location.`,
  'TreeDualSelector.source.default.txt': () => `Available items`,
  'TreeDualSelector.target.default.txt': () => `Selected items`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} of ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `No items`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filter`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Custom item`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} items added`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} items removed`,
  'TreeDualSelector.afterAction.addAll.txt': () => `All items are added`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `All items are removed`,
  'TreeDualSelector.afterAction.up.txt': () => `Moved up`,
  'TreeDualSelector.afterAction.down.txt': () => `Moved down`,
  'TreeDualSelector.afterAction.top.txt': () => `Moved to the top`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Moved to the bottom`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Add action reverted`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Remove action reverted`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `custom item added`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} custom item selected`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} selected`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} selected`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Move up one row in ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Move down one row in ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Move to the top of ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Move to the bottom of ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Add item to ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Add all to ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Remove item from ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Remove all from ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Undo add for ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Undo remove for ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Filter ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Remove`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Any custom items that you have selected for removal will be permanently deleted if you continue.\n\n Do you want to continue?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Remove All Items`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `The custom items in this list will be permanently deleted if you continue.\n\n Do you want to continue?`,
  'LinkNavigator.backButton.label': () => `Back`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Incoming Filters`,
  'LinkNavigator.reportLevel.label': () => `Report level`,
  'LinkNavigator.sectionLevel.label': () => `Page level`,
  'ReportSectionZeroState.heading.label': () => `Design a Report`,
  'ReportSectionZeroState.description.label': () => `Drag objects or data items onto the page, or select an option below.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Drag objects or data items onto the page, or start from a page template.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Generate object`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Select a template`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Explore suggestions`,
  'PromptContainerTooltip.noSelections.txt': () => `No selections`,
  'PromptContainerTooltip.selectedValues.txt': () => `Selected Values`,
}
export default localizers;
